import React from 'react'
import { SellableCardFragment, SellableType } from '#src/generated/graphql'
import V1ProductCard from './v1'
import V1ExperienceCard from '#src/components/ExperienceCard'

export interface SellableCardProps extends React.HTMLAttributes<HTMLDivElement> {
  sellable: SellableCardFragment
  position?: number
}

const SellableCard: React.SFC<SellableCardProps> = ({ ...props }) => {
  if (props.sellable.type === SellableType.SERVICE) {
    return <V1ExperienceCard {...props} />
  } else {
    return <V1ProductCard {...props} />
  }
}

export default SellableCard
